import React, { FC, useCallback, useState } from 'react';
import { ExtendedRenewalTile } from '../../utils/renewalTableTileTypes';
import { ExtendedRenewalOverviewRow } from './ExtendedRenewalOverview';
import { ExtendedRenewalIndividualRow } from './ExtendedRenewalIndividual';
import { ExtendedRenewalSharedRow } from './ExtendedRenewalShared';
import { useShowAll } from '../../../../shared/subscription-management/ShowAllContext';

export const ExtendedRenewalTableTile: FC<ExtendedRenewalTile> = props => {
    const [open, setOpen] = useState(true);

    const onShowAll = useCallback(() => setOpen(true), []);
    useShowAll(onShowAll);

    return (
        <>
            <ExtendedRenewalOverviewRow
                {...props.overview}
                copiesListOpen={open}
                toggleCopiesList={() => setOpen(!open)}
            />
            {open ? (
                <>
                    <ExtendedRenewalIndividualRow {...props.individual} />
                    <ExtendedRenewalSharedRow {...props.shared} />
                </>
            ) : null}
        </>
    );
};
